import { useGetMutualFundChartData } from '#/api/generated/mutual-fund/mutual-fund';

import { normalizeMutualFundChartData } from './normalize';
import { ProductTypeChartSection } from './ProductTypeChartSection';
import { MUTUAL_FUND_CHART_TIMEFRAME_TABS } from './timeframes';
import type { ChartTimeframeId } from './types';

interface MutualFundsChartSectionProps {
  symbol: string;
  initialTimeframe?: ChartTimeframeId;
  previousClose?: number | null;
}

export function MutualFundsChartSection({
  symbol,
  initialTimeframe = '1Y',
  previousClose,
}: MutualFundsChartSectionProps) {
  return (
    <ProductTypeChartSection
      symbol={symbol}
      initialTimeframe={initialTimeframe}
      tabs={MUTUAL_FUND_CHART_TIMEFRAME_TABS}
      useChartQuery={useGetMutualFundChartData}
      normalizeChartData={normalizeMutualFundChartData}
      tooltipFields={['close']}
      previousClose={previousClose}
    />
  );
}
